import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { RegexConstants } from '@wz-constants';
import { HealthModels } from '@wz-models';
import { LoggerService } from '@wz-services';
import {
  formatDate,
  getAgeFromDate,
  getDateUtc,
} from '@wz-utilities/date.utilities';
import { addDays } from 'date-fns';
import { StepperServiceBase } from 'libs/modules/tunnelsante-ui/components/stepper2/stepper.service';
import { MtxDataLoginResponse } from 'libs/modules/tunnelsante/services/api/api-service-base';
import { MtxApiService } from 'libs/modules/tunnelsante/services/api/mtx-api.service';
import { HealthInsuranceService } from 'libs/modules/tunnelsante/services/health-insurance.service';
import { DateTime } from 'luxon';
import { CookieService } from 'ngx-cookie';
import { Subscription } from 'rxjs';
import { Enfant } from '../devis-formulaire/Models/Enfant';
import { NiveauRemboursement } from '../devis-formulaire/Models/NiveauRemboursement';
import { Personne } from '../devis-formulaire/Models/Personne';
import { Question } from '../health-quotation-formB2C/factory-age-validators';
import { MyDataService } from '../services/my-data.service';

@Component({
  selector: 'wz-filtre-offres-b2c',
  templateUrl: './filtre-offres-b2c.component.html',
  styleUrls: ['./filtre-offres-b2c.component.scss'],
  standalone: false,
})
export class FiltreOffresB2CComponent implements OnInit {
  @Output() filtrePrixEvent = new EventEmitter();
  @Output() filtreNiveauEvent = new EventEmitter();

  changeFiltrePrix() {
    this.filtrePrixEvent.emit(this.filtrePrix);
  }

  filtrePrix: string = 'croissant';

  filtreDisplay: boolean = false;
  displayM: boolean = false;
  defaultcontrolListeParam!: Question[];
  enfant: Enfant = new Enfant(0, []);
  niveauRemboursement: NiveauRemboursement = new NiveauRemboursement(
    '',
    '',
    '',
    '',
    '',
  );
  public personne!: Personne | any;
  subscription: Subscription = new Subscription();

  DateNaissanceMin!: Date;
  formatDateNaissanceMin!: string | null;
  DateNaissanceMax!: Date;
  formatDateNaissanceMax!: string | null;
  healthEffectDateMin!: Date;
  formatDateEffetMin!: string | null;
  dateEffetMax!: Date;
  formatDateEffetMax!: string | null;
  dateEffetMaxPlus30!: Date;
  formatDateEffetMaxPlus30!: string | null;
  formatDateDebutContrat!: string | null;

  //Send data to formulaPickerComponent
  @Output() inFosPersonneEvent = new EventEmitter();

  @Input()
  nombreFormules!: string;

  valueAge: number = 0;
  valueRegimeSociale: string | null = '';
  regimeChanged: boolean = false;
  dateNaissanceChanged: boolean = false;
  imageUrlFamilleAvatar: string | any = 'assets/img/familleAvatar.svg';
  imageUrlClose: string | any = 'assets/img/close.svg';
  heartbeat_solid: string | any = 'assets/img/heartbeat-solid 1.svg';
  ambulanceFilter: string | any = 'assets/img/ambulance.svg';
  tooth_solid: string | any = 'assets/img/tooth-solid 1.svg';
  glasses_alt_regular: string | any = 'assets/img/glasses-alt-regular 1.svg';
  ear_solid: string | any = 'assets/img/ear-solid 1.svg';
  originContainer: string = '';
  colorCode: boolean = false;
  @Input() textNombreFormule!: string;
  @ViewChild('inputNom', { static: false }) inputNom!: NgModel;
  @ViewChild('inputPrenom', { static: false }) inputPrenom!: NgModel;
  classeValideButton: string = '';

  constructor(
    private stepperService: StepperServiceBase,
    private healthInsuranceService: HealthInsuranceService,
    private myDataService: MyDataService,
    private mtxApiService: MtxApiService,
    private cookieService: CookieService,
    private renderer: Renderer2,
    private el: ElementRef,
    private loggerService: LoggerService,
  ) {}

  data_value!: HealthModels.HealthQuotationStoredData | any;
  async ngOnInit() {
    this.subscription = this.myDataService.currentData.subscribe(
      (message: Personne) => {
        this.personne = message;
      },
    );

    this.personne = new Personne(
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      this.enfant,
      '',
      this.niveauRemboursement,
      '',
      '',
      '',
      false,
      localStorage.getItem('parrain') || '',
    );
    this.data_value = this.healthInsuranceService.getStoredData();
    this.defaultcontrolListeParam = this.data_value.controlListeParam;
    let dateDuJour = new Date();
    this.DateNaissanceMin = new Date(
      dateDuJour.getFullYear() - 90,
      dateDuJour.getMonth(),
      dateDuJour.getDate(),
    );
    this.formatDateNaissanceMin =
      formatDate(this.DateNaissanceMin, 'yyyy-MM-dd') ?? null;
    this.DateNaissanceMax = new Date(
      dateDuJour.getFullYear() - 18,
      dateDuJour.getMonth(),
      dateDuJour.getDate(),
    );
    this.formatDateNaissanceMax = formatDate(
      this.DateNaissanceMax,
      'yyyy-MM-dd',
    );
    this.healthEffectDateMin = this.getHealthEffectDateMin();
    this.formatDateEffetMin = formatDate(
      this.healthEffectDateMin,
      'yyyy-MM-dd',
    );
    this.dateEffetMax = dateDuJour;
    this.dateEffetMax.setDate(dateDuJour.getDate() + 365);
    this.formatDateEffetMax = formatDate(this.dateEffetMax, 'yyyy-MM-dd');
    
    let dateDuJourPlus30 = new Date();
    this.dateEffetMaxPlus30 = dateDuJourPlus30;
    this.dateEffetMaxPlus30.setDate(dateDuJourPlus30.getDate() + 30);
    this.formatDateEffetMaxPlus30 = formatDate(this.dateEffetMaxPlus30, 'yyyy-MM-dd');
    // if (this.defaultcontrolListeParam[9].QuestionValue != '') {
    //     this.restoreData();
    // }
    //Sharing data between unrelated component using myDataService
    //this.subscription = this.myDataService.currentData.subscribe((message: Personne) => { this.personne = message });

    this.getButtonClass();

    //Get data Personne Model in session storage
    const value = sessionStorage.getItem('app.personne');
    const valueDataPersonne = localStorage.getItem('data.client.personne');

    if (value) {
      //Set Personne modele
      this.personne = JSON.parse(value);
    }
    if (valueDataPersonne) {
      this.personne = JSON.parse(valueDataPersonne);
    }
    this.formatDateDebutContrat = formatDate(
      new Date(this.personne.dateDebutContrat),
      'dd-MM-yyyy',
    );

    let datasClientMTX = this.cookieService.get('datasClientMTX');

    if (datasClientMTX) {
      // sycn person form cookie
      await this.syncDataClientToPersonne();
      // formate dateNaissance
      let date = DateTime.fromFormat(
        this.personne.dateNaissanceAssure,
        'dd/LL/yyyy',
      ).toJSDate();
      this.personne.dateNaissanceAssure =
        DateTime.fromJSDate(date).toFormat('yyyy-LL-dd');
      // dateEffet
      let dateEffet = DateTime.fromFormat(
        this.personne.dateDebutContrat,
        'dd/LL/yyyy',
      ).toJSDate();
      this.personne.dateDebutContrat =
        DateTime.fromJSDate(dateEffet).toFormat('yyyy-LL-dd');
    }

    //SHOW AGE:
    if (this.personne.dateNaissanceAssure)
      this.valueAge = getAgeFromDate(this.personne.dateNaissanceAssure);
    else
      this.loggerService.log(
        "Erreur lors de la récupération de l'âge, " +
          this.personne.dateNaissanceAssure,
      );

    if (this.personne.regimeSocial)
      this.valueRegimeSociale = this.convertRegime(this.personne.regimeSocial);
    else
      this.loggerService.log(
        'Erreur lors de la récuperation du régime : ' +
          this.personne.regimeSocial,
      );

    this.applyStylesAndImages();
  }

  //  ngAfterViewInit() {
  //   this.applyStylesAndImages();

  // }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscription.unsubscribe();
  }

  displayFiltre() {
    this.filtreDisplay = !this.filtreDisplay;
    if (this.filtreDisplay) {
      this.applyStylesAndImages();
    }
  }

  backDevis() {
    // this.location.back();
    this.stepperService.goToStep(0);
  }

  restoreData() {
    if (this.defaultcontrolListeParam[0].QuestionValue != '0') {
      this.personne.compositionFamiliale =
        this.defaultcontrolListeParam[0].QuestionValue;
    }
    if (this.defaultcontrolListeParam[1].QuestionValue != '0') {
      this.personne.sexe = this.defaultcontrolListeParam[1].QuestionValue;
    }
    if (this.defaultcontrolListeParam[2].QuestionValue != '0') {
      this.personne.enfant.nombreEnfants =
        +this.defaultcontrolListeParam[2].QuestionValue;
    }
    if (this.defaultcontrolListeParam[3].QuestionValue != '0') {
      this.personne.dateNaissanceAssure =
        this.defaultcontrolListeParam[3].QuestionValue;
    }
    if (this.defaultcontrolListeParam[4].QuestionValue != '0') {
      this.personne.regimeSocial =
        this.defaultcontrolListeParam[4].QuestionValue;
    }
    if (this.defaultcontrolListeParam[5].QuestionValue != '0') {
      this.personne.dateNaissanceConjoint =
        this.defaultcontrolListeParam[5].QuestionValue;
    }
    if (this.defaultcontrolListeParam[6].QuestionValue != '0') {
      this.personne.conjointRegimeSociale =
        this.defaultcontrolListeParam[6].QuestionValue;
    }
    if (this.defaultcontrolListeParam[7].QuestionValue != '') {
      //enfant datenaiss
      var enfants = this.defaultcontrolListeParam[7].QuestionValue.split(';');
      // this.personne.enfant.dateNaissanceEnfant = new String[enfants.length];
      for (let i = 0; i < enfants.length; i++) {
        this.personne.enfant.dateNaissanceEnfant[i] = enfants[i];
      }
    }
    if (this.defaultcontrolListeParam[8].QuestionValue != '0') {
      this.personne.dateDebutContrat =
        this.defaultcontrolListeParam[8].QuestionValue;
    }
    if (this.defaultcontrolListeParam[9].QuestionValue != '') {
      //niveau r
      var niveauR = this.defaultcontrolListeParam[9].QuestionValue.split(';');
      const filteredArray = niveauR.filter(function (ele, pos) {
        return niveauR.indexOf(ele) == pos;
      });
      for (let i = 0; i < filteredArray.length; i++) {
        if (filteredArray[i].includes('Medicaux')) {
          this.personne.niveauRemboursement.soinsMedicaux = filteredArray[i]
            .split('Medicaux')[1]
            .toLowerCase();
        }
        if (filteredArray[i].includes('Hospi')) {
          this.personne.niveauRemboursement.hospi = filteredArray[i]
            .split('Hospi')[1]
            .toLowerCase();
        }
        if (filteredArray[i].includes('Dentaire')) {
          this.personne.niveauRemboursement.dentaire = filteredArray[i]
            .split('Dentaire')[1]
            .toLowerCase();
        }
        if (filteredArray[i].includes('Optique')) {
          this.personne.niveauRemboursement.optique = filteredArray[i]
            .split('Optique')[1]
            .toLowerCase();
        }
        if (filteredArray[i].includes('Audit')) {
          this.personne.niveauRemboursement.auditive = filteredArray[i]
            .split('Audit')[1]
            .toLowerCase();
        }
      }
    }
    if (this.defaultcontrolListeParam[10].QuestionValue != '0') {
      var nomPrenom =
        this.defaultcontrolListeParam[10].QuestionValue.split(';');
      this.personne.nom = nomPrenom[0];
      this.personne.prenom = nomPrenom[1];
    }
    if (this.defaultcontrolListeParam[11].QuestionValue != '0') {
      //departement
      // this.personne.compositionFamiliale = this.defaultcontrolListeParam[11].QuestionValue;
      this.personne.codePostal =
        this.defaultcontrolListeParam[11].QuestionValue;
    }
    if (this.defaultcontrolListeParam[12].QuestionValue != '0') {
      //contact
      var contact = this.defaultcontrolListeParam[12].QuestionValue.split(';');
      this.personne.telephone = contact[0];
      this.personne.email = contact[1];
    }
  }

  calcAge(dateNaissance: string) {
    let a = new Date().getTime();
    const formats = [
      'dd/MM/yyyy',
      'd/MM/yyyy',
      'dd/M/yyyy',
      'd/M/yyyy',
      'yyyy-MM-dd',
      'yyyy-MM-d',
      'yyyy-M-dd',
      'yyyy-M-d',
    ];

    let b: number = NaN;
    for (const format of formats) {
      const dt = DateTime.fromFormat(dateNaissance, format);
      if (dt.isValid) {
        b = dt.toJSDate().getTime();
        break;
      }
    }

    let timeDiff = Math.abs(a - b);
    let age = Math.round(timeDiff / (1000 * 3600 * 24) / 365.25);
    localStorage.setItem('AgeSouscripteur', age.toString());
    return age;
  }

  convertRegime(regimeInt: string): string | null {
    switch (regimeInt) {
      case '0':
        return 'Régime général';
      case '1':
        return 'Travailleur non salarié';
      case '2':
        return 'Sécurité sociale agricole';
      case '3':
        return 'Alsace-moselle';
      default:
        return null;
    }
  }
  toggleModdal() {
    if (
      this.personne.dateDebutContrat.length == 10 &&
      this.personne.dateNaissanceAssure.length == 10 &&
      !(this.personne.dateDebutContrat < this.formatDateEffetMin!) &&
      !(this.personne.dateDebutContrat > this.formatDateEffetMax!) &&
      !(this.personne.dateNaissanceAssure > this.formatDateNaissanceMax!) &&
      !(this.personne.dateNaissanceAssure < this.formatDateNaissanceMin!)
    ) {
      sessionStorage.setItem('app.personne', JSON.stringify(this.personne));
      this.myDataService.changeData(this.personne);
      this.formatDateDebutContrat = formatDate(
        new Date(this.personne.dateDebutContrat),
        'dd-MM-yyyy',
      );
      this.displayM = !this.displayM;
      localStorage.setItem(
        'data.client.personne',
        JSON.stringify(this.personne),
      );
      this.applyStylesAndImages();
    }
  }
  value!: HealthModels.HealthQuotationStoredData;

  validateUpdate() {
    this.calcAge(this.personne.dateNaissanceAssure);
    if (window['tC']) {
      let age: any = localStorage.getItem('AgeSouscripteur');
      let ageDouble = 0;

      let datatc: any = {
        event_id: 'action',
        event_categorie: 'modification criteres',
        event_nom: 'modification statut',
        // 'event_lead_beneficiaire': 'retourner le nombre' // à modifier
      };

      if (!isNaN(parseFloat(age))) {
        ageDouble = parseFloat(age);
      }

      if (ageDouble >= 0) {
        datatc['event_user_age'] = ageDouble + '';
        if (window['tc_vars'])
          window['tc_vars']['event_user_age'] = ageDouble + '';
      }

      window['tC'].event.action(this, datatc);
    }

    //Change session storage
    sessionStorage.setItem('app.personne', JSON.stringify(this.personne));
    localStorage.setItem('data.client.personne', JSON.stringify(this.personne));
    this.myDataService.changeData(this.personne);
    this.formatDateDebutContrat = formatDate(
      new Date(this.personne.dateDebutContrat),
      'dd-MM-yyyy',
    );

    //Update controlListeParam with new data from Model Personne:
    this.setQuestionValue(
      'NomPrenom',
      this.personne.nom + ';' + this.personne.prenom,
    );
    this.setQuestionValue('DateDebutContrat', this.personne.dateDebutContrat);
    this.setQuestionValue('DateNaissance', this.personne.dateNaissanceAssure);
    this.setQuestionValue('RegimeSocial', this.personne.regimeSocial);

    // update quotaion form
    if (this.data_value.quotationForm.assureInfos) {
      this.data_value.quotationForm.assureInfos.nom = this.personne.nom;
      this.data_value.quotationForm.assureInfos.prenom = this.personne.prenom;

      let dateNaissanceAssureePricipal = formatDate(
        new Date(this.personne.dateNaissanceAssure),
        'yyyy-MM-dd',
      );
      let dateEffetAssureePricipal = formatDate(
        new Date(this.personne.dateDebutContrat),
        'yyyy-MM-dd',
      );
      this.data_value.quotationForm.assurePrincipal.dateEffet =
        dateEffetAssureePricipal;
      this.data_value.quotationForm.assurePrincipal.dateNaissance =
        dateNaissanceAssureePricipal;
    }

    this.data_value.controlListeParam = this.defaultcontrolListeParam; //update data with new controlListeParam:
    this.healthInsuranceService.setData(this.data_value); //in storedData

    //Set new data in formula picker component
    this.inFosPersonneEvent.emit(this.defaultcontrolListeParam);

    this.displayM = !this.displayM; //close modal

    //Changer affichage si valeurs dans modal ont changées
    if (this.regimeChanged) {
      this.valueRegimeSociale = this.convertRegime(this.personne.regimeSocial);
      this.regimeChanged = false;
    }

    if (this.dateNaissanceChanged) {
      this.valueAge = getAgeFromDate(this.personne.dateNaissanceAssure);
      this.dateNaissanceChanged = false;
    }
  }

  changeName(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let inputValue = (event.target as HTMLInputElement).value;
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['lastName'] = inputValue;
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          nom: inputValue,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
  }

  changeFirstName(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let inputValue = (event.target as HTMLInputElement).value;
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['firstName'] = inputValue;
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          prenom: inputValue,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
  }

  changeDateNaissance(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let inputValue = (event.target as HTMLInputElement).value;

    let date = new Date(inputValue);
    let formater = DateTime.fromJSDate(date).toFormat('dd/LL/yyyy');
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['dateOfBirth'] = formater;
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          dateNaissanceAssure: formater,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
    this.dateNaissanceChanged = true;
  }

  changeDateEffect(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let inputValue = (event.target as HTMLInputElement).value;

    let date = new Date(inputValue);
    let formater = DateTime.fromJSDate(date).toFormat('dd/LL/yyyy');
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          dateDebutContrat: formater,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
  }

  changeRegimeSocial(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let inputValue = (event.target as HTMLInputElement).value;

    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          regimeSocial: inputValue,
          RegimeSocial: inputValue,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
    this.regimeChanged = true;
  }

  async syncDataClientToPersonne(key: string | null = null, value: any = null) {
    let datasClientMTX = this.cookieService.get('datasClientMTX');

    if (datasClientMTX) {
      datasClientMTX = datasClientMTX.replace(/(%2B)/g, '+');
      datasClientMTX = datasClientMTX.replace(/(<script>.*<\/script>)/g, '');

      let tokenMtx = localStorage.getItem('mtx-token');
      if (tokenMtx) {
        let token: MtxDataLoginResponse = JSON.parse(tokenMtx);
        let exp: number = new Date(token.expiration).getTime();
        let date: number = new Date().getTime();

        const diffInMinutes = Math.floor((exp - date) / (1000 * 60));
        if (diffInMinutes < 10) {
          this.mtxApiService.getToken().subscribe((token) => {
            if (token && token.data && token.data.token) {
              localStorage.setItem('mtx-token', JSON.stringify(token.data));
            }
          });
        }
      } else {
        this.mtxApiService.getToken().subscribe((token) => {
          if (token && token.data && token.data.token) {
            localStorage.setItem('mtx-token', JSON.stringify(token.data));
          }
        });
      }

      let data: any = await this.mtxApiService.letDecrypt(datasClientMTX);
      if (data && data.request) {
        this.mtxApiService.saveDataClient(data.request);
      }
    }

    let dataCleinta = localStorage.getItem('dataCleint');
    if (dataCleinta) {
      let dataClientObject = JSON.parse(dataCleinta);

      this.personne.nom = dataClientObject.lastName;
      this.personne.prenom = dataClientObject.firstName;
      this.personne.email = dataClientObject.email;

      if (
        dataClientObject.mobilePhone &&
        dataClientObject.mobilePhone.length >= 10
      ) {
        dataClientObject.mobilePhone = dataClientObject.mobilePhone.replace(
          /\s/g,
          '',
        );
        this.personne.telephone = this.getPhoneNumberValidate(
          dataClientObject.mobilePhone,
        );
      }

      if (dataClientObject.mailingINSEE) {
        this.personne.codePostal = dataClientObject.mailingINSEE;
      }

      if (dataClientObject.mailingPostalCode) {
        this.personne.codePostal = dataClientObject.mailingPostalCode;
      }

      if (dataClientObject.dateOfBirth) {
        this.personne.dateNaissanceAssure = dataClientObject.dateOfBirth;
      }

      if (dataClientObject['MT.Wazzari.sante']) {
        $.each(dataClientObject['MT.Wazzari.sante'], (k: string, v) => {
          let keyy = key;
          switch (k) {
            case 'CompositionFamiliale':
              if (keyy && keyy == 'compositionFamiliale')
                this.personne['compositionFamiliale'] = value;
              else this.personne['compositionFamiliale'] = v;

              break;
            case 'RegimeSocial':
              this.personne['regimeSocial'] = v;

              break;
            case 'etre_contacte_par_telephone':
              this.personne['etre_contacte_par_telephone'] = v;
              if (v == true) {
                localStorage.setItem('acceptCompMT', '1');
              } else {
                localStorage.setItem('acceptCompMT', '0');
              }
              break;

            case 'NiveauRemboursement':
              this.personne['niveauRemboursement'] = v;
              this.setQuestionValue(
                'NiveauRemboursement',
                'Medicaux' +
                  this.personne.niveauRemboursement.soinsMedicaux +
                  ';' +
                  'Hospi' +
                  this.personne.niveauRemboursement.hospi +
                  ';' +
                  'Dentaire' +
                  this.personne.niveauRemboursement.dentaire +
                  ';' +
                  'Optique' +
                  this.personne.niveauRemboursement.optique +
                  ';' +
                  'Audit' +
                  this.personne.niveauRemboursement.auditive +
                  ';',
              );

              break;

            default:
              let ky = this.mtxApiService.uncapitalize(k);

              if (ky == 'conjointRegimeSocial') ky = 'conjointRegimeSociale';
              if (value == '1') {
                let notSync = [
                  'enfant',
                  'conjointRegimeSociale',
                  'dateNaissanceConjoint',
                ];

                if (!notSync.includes(ky)) {
                  this.personne[ky] = v;
                }
              } else if (value == '2') {
                let notSync = [
                  'conjointRegimeSociale',
                  'dateNaissanceConjoint',
                ];
                if (!notSync.includes(ky)) {
                  this.personne[ky] = v;
                }
              } else if (value == '3') {
                let notSync = ['enfant'];

                if (!notSync.includes(ky)) {
                  this.personne[ky] = v;
                }
              } else if (value == '4') {
                let notSync: any = [];
                if (!notSync.includes(ky)) {
                  this.personne[ky] = v;
                }

                if (this.personne['conjointRegimeSociale']) {
                  //
                }
              } else {
                this.personne[ky] = v;
              }
              break;
          }
        });
      }

      if (dataClientObject.salutation) {
        this.personne.sexe = dataClientObject.salutation == 'M.' ? '2' : '1';
      }

      if (key == 'compositionFamiliale') {
        this.personne.compositionFamiliale = value;
      }

      if (this.personne.enfant) {
        this.personne.enfant.nombreEnfants =
          this.personne.enfant.dateNaissanceEnfant.length;
      }

      if (this.personne.niveauRemboursement) {
        this.setQuestionValue(
          'NiveauRemboursement',
          'Medicaux' +
            this.personne.niveauRemboursement.soinsMedicaux +
            ';' +
            'Hospi' +
            this.personne.niveauRemboursement.hospi +
            ';' +
            'Dentaire' +
            this.personne.niveauRemboursement.dentaire +
            ';' +
            'Optique' +
            this.personne.niveauRemboursement.optique +
            ';' +
            'Audit' +
            this.personne.niveauRemboursement.auditive +
            ';',
        );
      }

      if (this.personne.compositionFamiliale == '1') {
        this.personne.dateNaissanceConjoint = '';
        this.personne.conjointRegimeSociale = '';
        this.personne.enfant = new Enfant(0, []);
      } else if (this.personne.compositionFamiliale == '2') {
        this.personne.dateNaissanceConjoint = '';
        this.personne.conjointRegimeSociale = '';

        if (this.personne.enfant) {
          this.personne.enfant.nombreEnfants =
            this.personne.enfant.dateNaissanceEnfant.length;
        }
      } else if (this.personne.compositionFamiliale == '3') {
        this.personne.enfant = new Enfant(0, []);
      } else if (this.personne.compositionFamiliale == '4') {
        if (this.personne.enfant) {
          this.personne.enfant.nombreEnfants =
            this.personne.enfant.dateNaissanceEnfant.length;
        }
      }
      this.personne.codeParrain = localStorage.getItem('parrain') || '';
      localStorage.setItem('app.personne', JSON.stringify(this.personne));
      localStorage.setItem(
        'data.client.personne',
        JSON.stringify(this.personne),
      );
      //modify stored data
    }

    this.personne.codeParrain = localStorage.getItem('parrain') || '';
  }

  getPhoneNumberValidate(phoneNumber: string) {
    if (!RegexConstants.AllPhone.test(phoneNumber)) {
      return '';
    }

    return (
      '0' + phoneNumber.substr(phoneNumber.length - 9, phoneNumber.length - 1)
    );
  }
  validateUpdateNvRemb() {
    if (window['tC']) {
      this.calcAge(this.personne.dateNaissanceAssure);
      let age: any = localStorage.getItem('AgeSouscripteur');
      let ageDouble = 0;

      let datatc: any = {
        event_id: 'action',
        event_categorie: 'modification criteres',
        event_nom: 'modification besoins',
        event_lead_soins: this.personne.niveauRemboursement.soinsMedicaux,
        event_lead_hospitalisation: this.personne.niveauRemboursement.hospi,
        event_lead_dentaire: this.personne.niveauRemboursement.dentaire,
        event_lead_optique: this.personne.niveauRemboursement.optique,
        event_lead_auditive: this.personne.niveauRemboursement.auditive,
      };

      if (!isNaN(parseFloat(age))) {
        ageDouble = parseFloat(age);
      }

      if (ageDouble >= 0) {
        datatc['event_user_age'] = ageDouble + '';
        if (window['tc_vars'])
          window['tc_vars']['event_user_age'] = ageDouble + '';
      }
      window['tC'].event.action(this, datatc);
    }

    //Change session storage
    sessionStorage.setItem('app.personne', JSON.stringify(this.personne));
    this.myDataService.changeData(this.personne);
    localStorage.setItem('data.client.personne', JSON.stringify(this.personne));
    //Update controleListeParam
    this.setQuestionValue(
      'NiveauRemboursement',
      'Medicaux' +
        this.personne.niveauRemboursement.soinsMedicaux +
        ';' +
        'Hospi' +
        this.personne.niveauRemboursement.hospi +
        ';' +
        'Dentaire' +
        this.personne.niveauRemboursement.dentaire +
        ';' +
        'Optique' +
        this.personne.niveauRemboursement.optique +
        ';' +
        'Audit' +
        this.personne.niveauRemboursement.auditive +
        ';',
    );

    this.data_value.controlListeParam = this.defaultcontrolListeParam; //update data with new controlListeParam:
    this.healthInsuranceService.setData(this.data_value);

    this.filtreNiveauEvent.emit(this.defaultcontrolListeParam);
  }

  private getHealthEffectDateMin(): Date {
    return addDays(getDateUtc() ?? new Date(), 1);
  }

  setQuestionValue(keyString: any, valeur: any) {
    var find_object: any = this.defaultcontrolListeParam.find(
      (x) => x.KeyQ == keyString,
    );

    if (keyString == 'EnfantsDateNaissance') {
      find_object.QuestionValue += valeur + ';';
    } else {
      find_object.QuestionValue = valeur;
    }
  }

  ngOnChanges() {
    if (this.textNombreFormule) {
      this.changeNombreFormuleTextColor(this.textNombreFormule);
    }
  }

  changeNombreFormuleTextColor(color: string) {
    const element = this.el.nativeElement.querySelector('.nombreFormule span');
    if (element) {
      this.renderer.setStyle(element, 'color', color);
    }
  }

  applyStylesAndImages() {
    const CodeOrigin = localStorage.getItem('codeOrigin');

    let exeptcode: string = '';
    let classContainer: string = '';
    let avatarFamilly: string = '';
    let modalClose: string = '';
    let imgsrcDomFilter = {};

    switch (CodeOrigin) {
      case 'assuranceetmutuelle_affiliation':
        exeptcode = 'assuranceetmutuelle_affiliation';
        classContainer = 'editAssuranceEtMutuelleContainer';
        avatarFamilly = 'assets/img/familleAvatar_assurance_et_mutuelle.svg';
        modalClose = 'assets/img/close-green.svg';
        imgsrcDomFilter = {
          soinsMedicaux:
            'assets/img/heartbeat-solid-assurance-et-mutuelle 1.svg',
          ambulance: 'assets/img/ambulance-assurance-et-mutuelle.svg',
          dentaire: 'assets/img/tooth-solid 1-assurance-et-mutuelle.svg',
          optique: 'assets/img/glasses-alt-regular-1-assurance-et-mutuelle.svg',
          audit: 'assets/img/ear-solid 1-assurance-et-mutuelle.svg',
        };
        break;
      case 'afisante_affiliation':
        exeptcode = 'afisante_affiliation';
        classContainer = 'editafisante_affiliation';
        avatarFamilly = 'assets/img/familleAvatar_afi_sante.svg';
        modalClose = 'assets/img/close_afisante.svg';
        imgsrcDomFilter = {
          soinsMedicaux: 'assets/img/heartbeat-solid-afisante 1.svg',
          ambulance: 'assets/img/ambulance-afisante.svg',
          dentaire: 'assets/img/tooth-solid 1-afisante.svg',
          optique: 'assets/img/glasses-alt-regular 1-afisante.svg',
          audit: 'assets/img/ear-solid 1-afisante.svg',
        };
        break;
      case 'mutuelleonline_affiliation':
        exeptcode = 'mutuelleonline_affiliation';
        classContainer = 'editmutuelleonline_affiliation';
        avatarFamilly = 'assets/img/familleAvatar_mutuelle_online.svg';
        modalClose = 'assets/img/close_mutuelle_online.svg';
        imgsrcDomFilter = {
          soinsMedicaux: 'assets/img/heartbeat-solid-mutuelle-online 1.svg',
          ambulance: 'assets/img/ambulance-mutuelle-online.svg',
          dentaire: 'assets/img/tooth-solid 1-mutuelle-online.svg',
          optique: 'assets/img/glasses-alt-regular 1-mutuelle-online.svg',
          audit: 'assets/img/ear-solid 1-mutuelle-online.svg',
        };
        break;
      case 'labonnemutuelle_affiliation':
        exeptcode = 'labonnemutuelle_affiliation';
        classContainer = 'editlabonnemutuelle_affiliation';
        avatarFamilly = 'assets/img/familleAvatar_la_bonne_mutuelle.svg';
        modalClose = 'assets/img/close_la_bonne_mutuelle.svg';
        imgsrcDomFilter = {
          soinsMedicaux: 'assets/img/heartbeat-solid-labonnemutuelle 1.svg',
          ambulance: 'assets/img/ambulance-labonnemutuelle.svg',
          dentaire: 'assets/img/tooth-solid 1-labonnemutuelle.svg',
          optique: 'assets/img/glasses-alt-regular 1-labonnemutuelle.svg',
          audit: 'assets/img/ear-solid 1-labonnemutuelle.svg',
        };
        break;
      default:
        break;
    }

    if (CodeOrigin == exeptcode) {
      this.originContainer = classContainer;
      this.updateModal({
        familleAvatar: avatarFamilly,
        closeModal: modalClose,
      });
      this.updateFilter(imgsrcDomFilter);
    }
  }

  private updateModal(imgSrcs: {
    familleAvatar?: string;
    closeModal?: string;
  }) {
    this.colorCode = true;
    this.imageUrlFamilleAvatar = imgSrcs.familleAvatar;
    this.imageUrlClose = imgSrcs.closeModal;
  }

  private updateFilter(imgSrcs: {
    soinsMedicaux?: string;
    ambulance?: string;
    dentaire?: string;
    optique?: string;
    audit?: string;
  }) {
    this.heartbeat_solid = imgSrcs.soinsMedicaux;
    this.ambulanceFilter = imgSrcs.ambulance;
    this.tooth_solid = imgSrcs.dentaire;
    this.glasses_alt_regular = imgSrcs.optique;
    this.ear_solid = imgSrcs.audit;
  }

  getButtonClass() {
    const CodeOrigin = localStorage.getItem('codeOrigin');
    switch (CodeOrigin) {
      case 'assuranceetmutuelle_affiliation':
        this.classeValideButton = 'vertButton';
        break;
      case 'afisante_affiliation':
        this.classeValideButton = 'bleu';
        break;
      case 'mutuelleonline_affiliation':
        this.classeValideButton = 'rougeButton';
        break;
      case 'labonnemutuelle_affiliation':
        this.classeValideButton = 'vertBonneMutuelle';
        break;
      default:
        this.classeValideButton = 'orange';
        break;
    }
  }
}
